"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.initialAuthgState = void 0;
const auth_1 = require("../../auth");
const types_1 = require("./types");
exports.initialAuthgState = {
    check: false,
    user: null,
    verified: false,
    passed_gdpr: true,
};
function authReducer(state = exports.initialAuthgState, action) {
    switch (action.type) {
        case types_1.AUTH_UPDATE:
            return {
                check: auth_1.Auth.check(),
                user: auth_1.Auth.getUser(),
                verified: auth_1.Auth.isVerified(),
                passed_gdpr: auth_1.Auth.hasToken() ? state.passed_gdpr : true,
            };
        case types_1.UNAVAILABLE_GDPR:
            return {
                check: auth_1.Auth.check(),
                user: auth_1.Auth.getUser(),
                verified: auth_1.Auth.isVerified(),
                passed_gdpr: auth_1.Auth.hasToken() ? action.passed : true,
            };
        default:
            return state;
    }
}
exports.authReducer = authReducer;
